import { render, staticRenderFns } from "./verticalTabs.vue?vue&type=template&id=73838222&scoped=true&"
import script from "./verticalTabs.vue?vue&type=script&lang=js&"
export * from "./verticalTabs.vue?vue&type=script&lang=js&"
import style0 from "./verticalTabs.vue?vue&type=style&index=0&id=73838222&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73838222",
  null
  
)

export default component.exports